import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { handleHttpError } from '../utils/common';
import useAxios from './useAxios';
import { OnlyFansSubscriber } from './useSubscriber';

export interface OnlyFansMetricsSubscribedAtVsTotalSalesDetailsDataPoint {
    _id: {
        interval: Date;
        createdAt: Date;
    };
    count: number;
    total?: number;
    totalNet?: number;
    totalWithoutSubscriptions?: number;
    totalNetWithoutSubscriptions?: number;
}

const useSextforceMetricsGroupsSubscribedAtVsTotalSalesDetails = (
    subscriber: OnlyFansSubscriber | undefined,
    groupId: string | undefined,
    timezone: string,
) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const params = useParams();
    const dialog = useDialog();
    const axios = useAxios();

    // Fetch Report
    const fetchReport = async (): Promise<OnlyFansMetricsSubscribedAtVsTotalSalesDetailsDataPoint[]> => {
        const query: string = `${settingsContext.routes.metrics.base}${params.userId}/groups/${groupId}/subscribedat?timezone=${timezone}`;

        const data = await axios
            .get(query)
            .then(response => response.data)
            .catch(error => {
                console.error(error);

                handleHttpError(error, dialog);

                return [];
            });

        return data;
    };

    return useQuery(['metricsGroupSubscribedAtVsSales', subscriber?._id, groupId, timezone], () => fetchReport(), {
        refetchOnWindowFocus: false,
        staleTime: 60 * 60 * 1000,
        enabled: userContext.jwtToken && settingsContext.apiKey && params.userId && subscriber && subscriber._id && groupId ? true : false,
    });
};

export default useSextforceMetricsGroupsSubscribedAtVsTotalSalesDetails;
